import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSidebarSimpleIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.5 2.25H2.5C2.16848 2.25 1.85054 2.3817 1.61612 2.61612C1.3817 2.85054 1.25 3.16848 1.25 3.5V12.5C1.25 12.8315 1.3817 13.1495 1.61612 13.3839C1.85054 13.6183 2.16848 13.75 2.5 13.75H13.5C13.8315 13.75 14.1495 13.6183 14.3839 13.3839C14.6183 13.1495 14.75 12.8315 14.75 12.5V3.5C14.75 3.16848 14.6183 2.85054 14.3839 2.61612C14.1495 2.3817 13.8315 2.25 13.5 2.25ZM2.75 3.75H4.75V12.25H2.75V3.75ZM13.25 12.25H6.25V3.75H13.25V12.25Z",
		fill: "currentColor"
	})
});
export default SvgSidebarSimpleIcon;
